import { createPopper } from '@popperjs/core';

export const flashMessageListener = () => {
    window.flashMessage = (payload) => {
        const containerElement = document.querySelector(payload.target);
        const parser = new DOMParser();
        const shadowElement = parser.parseFromString(payload.html, 'text/html');

        document.body.append(shadowElement.body.firstElementChild);

        const popperElement = document.body.lastElementChild;

        const popperInstance = createPopper(containerElement, popperElement, {
            placement: 'top',
            modifiers: [
                {
                    name: 'matchReferenceSize',
                    enabled: true,
                    phase: 'beforeWrite',
                    requires: ['computeStyles'],
                    fn({ state }) {
                        state.styles.popper.width = `${state.rects.reference.width}px`;
                        state.styles.popper.height = `${state.rects.reference.height}px`;
                    },
                    effect({ state }) {
                        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
                        state.elements.popper.style.height = `${state.elements.reference.offsetHeight}px`;
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: ({ reference, placement, popper }) => [
                            0,
                            ['top', 'bottom'].includes(placement)
                                ? -reference.height - (popper.height - reference.height) / 2
                                : -reference.width - (popper.width - reference.width) / 2,
                        ],
                    },
                },
            ],
        });

        popperElement.classList.add('show');

        setTimeout(() => {
            popperElement.classList.remove('show');

            popperElement.addEventListener(
                'transitionend',
                () => {
                    popperInstance.destroy();
                    popperElement.remove();
                },
                { once: true }
            );
        }, payload.interval ?? 2000);
    };
};
